export const PRIZM_DROPDOWN_DEFAULT_MIN_HEIGHT = 80;
export const PRIZM_DROPDOWN_DEFAULT_MAX_HEIGHT = 400;
